import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import React from 'react'

import Spinner from './Spinner'
interface IPageLoader extends HTMLAttributes<HTMLDivElement> {
    size?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
    className?: string
}
const PageLoader = ({ size = 'lg', className = '', ...props }: IPageLoader) => {
    return (
        <div
            className={clsx(
                'flex-auto flex items-center justify-center',
                className,
            )}
            {...props}
        >
            <Spinner size={size} />
        </div>
    )
}

export default PageLoader
